var map = {
  "./cs.json": [
    "GC",
    [
      "kb"
    ]
  ],
  "./en.json": [
    "Pa",
    [
      "t1"
    ]
  ],
  "./pl.json": [
    "gA",
    [
      "60p"
    ]
  ],
  "./ru.json": [
    "KUM",
    [
      "wz"
    ]
  ],
  "./tr.json": [
    "AP",
    [
      60
    ]
  ],
  "./ja.json": [
    "ZjN",
    [
      "j7c"
    ]
  ],
  "./zh.json": [
    "iC",
    [
      "8s"
    ]
  ],
  "./pt-br.json": [
    "xR",
    [
      "n3n"
    ]
  ],
  "./de.json": [
    "ZfX",
    [
      33
    ]
  ],
  "./es.json": [
    "t0x",
    [
      "n57"
    ]
  ],
  "./fr.json": [
    "yw",
    [
      "4p"
    ]
  ],
  "./it.json": [
    "xUf",
    [
      "fy"
    ]
  ],
  "./ko.json": [
    "wx",
    [
      655
    ]
  ],
  "./pt.json": [
    "xm",
    [
      "nkb"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "we";
module.exports = __rspack_async_context;
